import { ioc } from 'internal-ioc';
import _ from 'lodash';

ioc.define('_', _);
ioc.define('window', window);

export { ioc };
